export default __webpack_public_path__ + "static/media/stacked-steps-haikei.30878880.svg";